import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { StrictMode } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/custom.css';

import Login from './components/LoginComponent';
import DashboardComponent from './components/DashboardComponent';
import SimpleFormComponent from './components/SimpleFormComponent';
import TemplateComponent from './components/template/TemplateComponent';
import CreateTemplateComponent from './components/template/CreateTemplateComponent';
import CampaignComponent from './components/campaign/CampaignComponent';
import CreateCampaignComponent from './components/campaign/CreateCampaignComponent';
import BlankComponent from './components/BlankComponent';
import ManageContactsComponent from './components/Contact/ManageContactsComponent';
import CreateContactGroupComponent from './components/Contact/CreateContactGroupComponent';
import ChangePasswordComponent from './components/manageUser/ChangePassword';
import ManageUserComponent from './components/manageUser/ManageUserComponent';
import CreateUserComponent from './components/manageUser/CreateUserComponent';
import WhatsappProfileComponent from './components/manageUser/WhatsappProfileComponent';
import CreateWhatsappProfileComponent from './components/manageUser/CreateWhatsappProfileComponent';
import CreditHistoryComponent from './components/manageUser/CreditHistoryComponent';
import ManageRolesComponent from './components/manageUser/ManageRoles';
import UserRolesComponent from './components/manageUser/UserRolesComponent';
import ChatAgent from './components/ChatAgent/ChatAgent';
import DetailedReportComponent from './components/Reporting/DetailedReportComponent';
import SummaryReportComponent from './components/Reporting/SummaryReportComponent';
import SegmentationComponent from './components/Segmentation/SegmentationComponent';
import CreateSegmentComponent from './components/Segmentation/CreateSegmentComponent';
import EditSegmentComponent from './components/Segmentation/EditSegmentComponent';
import DataConverseComponent from './components/DataConverse/DataConverseComponent';
import CreateDataConverseComponent from './components/DataConverse/CreateDataConverseComponent';
import ProtectedRoute from './components/commonComponents/ProtectedRoute';
import NotAuthorized from './components/commonComponents/NotAuthorized';
import SequenceDashboard from './components/Automation/Sequence/SequenceDashboard';
import CreateSequence from './components/Automation/Sequence/CreateSequence';
import TagsComponent from './components/Contact/TagsComponent';
import ChatPage from './components/WebChat/ChatPage';
import MediaComponent from './components/media/MediaComponent';

import Flows          from './components/pages/Flows';
import AgentConfig    from './components/pages/AgentConfig';
import AgentPanel     from './components/pages/AgentPanel';
import KnowledgeBase  from './components/pages/KnowledgeBase';
import LearningReview from './components/pages/LearningReview';
import FlowBuilder from './components/pages/FlowBuilder';
import TestChat from './components/pages/TestChat';
import Agents          from './components/pages/Agents';
import CreateAgent    from './components/pages/CreateAgent';
import PlatformSettings from './components/pages/PlatformSettings';
import TenantSettings  from './components/pages/TenantSettings';
import Tools           from './components/pages/Tools';
import CreateTool      from './components/pages/CreateTool';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />
        <Route path="/not-authorized" element={<NotAuthorized />} />

        {/* All authenticated routes wrapped in ProtectedRoute */}
        <Route path="/dashboard" element={<ProtectedRoute><DashboardComponent /></ProtectedRoute>} />
        <Route path="/testform" element={<ProtectedRoute><SimpleFormComponent /></ProtectedRoute>} />
        <Route path="/template" element={<ProtectedRoute><TemplateComponent /></ProtectedRoute>} />
        <Route path="/createTemplate" element={<ProtectedRoute><CreateTemplateComponent /></ProtectedRoute>} />
        <Route path="/campaign" element={<ProtectedRoute><CampaignComponent /></ProtectedRoute>} />
        <Route path="/createCampaign" element={<ProtectedRoute><CreateCampaignComponent /></ProtectedRoute>} />
        <Route path="/blank" element={<ProtectedRoute><BlankComponent /></ProtectedRoute>} />
        <Route path="/manageContacts" element={<ProtectedRoute><ManageContactsComponent /></ProtectedRoute>} />
        <Route path="/createContactGroup" element={<ProtectedRoute><CreateContactGroupComponent /></ProtectedRoute>} />
        <Route path="/changepassword" element={<ProtectedRoute><ChangePasswordComponent /></ProtectedRoute>} />
        <Route path="/manageuser" element={<ProtectedRoute><ManageUserComponent /></ProtectedRoute>} />
        <Route path="/manageuserrole" element={<ProtectedRoute><ManageRolesComponent /></ProtectedRoute>} />
        {/* <Route path="/createuser" element={<ProtectedRoute><CreateUserComponent /></ProtectedRoute>} /> */}
        <Route path="/createuser" element={<CreateUserComponent />} />
        <Route path="/whatsappprofile" element={<ProtectedRoute><WhatsappProfileComponent /></ProtectedRoute>} />
        <Route path="/createwhatsappprofile" element={<CreateWhatsappProfileComponent />} />
        {/* <Route path="/createwhatsappprofile" element={<ProtectedRoute><CreateWhatsappProfileComponent /></ProtectedRoute>} /> */}
        <Route path="/credithistory" element={<ProtectedRoute><CreditHistoryComponent /></ProtectedRoute>} />
        {/* <Route path="/userrole" element={<ProtectedRoute><UserRolesComponent /></ProtectedRoute>} /> */}
        <Route path="/userrole" element={<UserRolesComponent />} />
        {/* <Route path="/segmentation" element={<ProtectedRoute><SegmentationComponent /></ProtectedRoute>} /> */}
        <Route path="/segmentation" element={<SegmentationComponent />} />
        <Route path="/createsegmentation" element={<CreateSegmentComponent />} />
        <Route path="/editsegment" element={<EditSegmentComponent />} />
        {/* <Route path="/createsegmentation" element={<ProtectedRoute><CreateSegmentComponent /></ProtectedRoute>} />
        <Route path="/editsegment" element={<ProtectedRoute><EditSegmentComponent /></ProtectedRoute>} /> */}
        <Route path="/chatagent" element={<ProtectedRoute><ChatAgent /></ProtectedRoute>} />
        <Route path="/detailedreport" element={<DetailedReportComponent />} />
        <Route path="/summaryreport" element={<SummaryReportComponent />} />
        {/* <Route path="/detailedreport" element={<ProtectedRoute><DetailedReportComponent /></ProtectedRoute>} />
        <Route path="/summaryreport" element={<ProtectedRoute><SummaryReportComponent /></ProtectedRoute>} /> */}
        <Route path="/dataconverse" element={<ProtectedRoute><DataConverseComponent /></ProtectedRoute>} />
        <Route path="/createdataconverse" element={<ProtectedRoute><CreateDataConverseComponent /></ProtectedRoute>} />
        <Route path="/sequence" element={<ProtectedRoute><SequenceDashboard /></ProtectedRoute>} />
        <Route path="/createsequence" element={<ProtectedRoute><CreateSequence /></ProtectedRoute>} />
        <Route path="/tags" element={<TagsComponent />} />
        {/* <Route path="/tags" element={<ProtectedRoute><TagsComponent /></ProtectedRoute>} /> */}
        <Route path="/chat" element={<ProtectedRoute><ChatPage /></ProtectedRoute>} />
        <Route path="/media" element={<ProtectedRoute><MediaComponent /></ProtectedRoute>} />
        {/* <Route path="/flows/builder" element={<ProtectedRoute><FlowBuilder /></ProtectedRoute>} /> */}
        <Route path="/flows/builder" element={<FlowBuilder />} />

        <Route path="/flows"          element={<Flows />} />
        <Route path="/agentconfig"    element={<AgentConfig />} />
        <Route path="/agentpanel"     element={<AgentPanel />} />
        <Route path="/knowledgebase"  element={<KnowledgeBase />} />
        <Route path="/learningreview" element={<LearningReview />} />
        <Route path="/testchat" element={<TestChat />} />
        <Route path="/agents" element={<Agents />} />
        <Route path="/agents/create" element={<CreateAgent />} />
        <Route path="/platform-settings" element={<PlatformSettings />} />
        <Route path="/settings" element={<TenantSettings />} />
        <Route path="/tools" element={<Tools />} />
        <Route path="/tools/create" element={<CreateTool />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
);
